import React from "react"

export default function ArrowRight({ color }) {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="vuesax/linear/arrow-right">
        <g id="arrow-right">
          <path
            id="Vector"
            d="M11.4238 5.19482L16.2292 10.0002L11.4238 14.8057"
            stroke="#FF0000"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M2.771 10H16.0947"
            stroke="#FF0000"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  )
}
